import { ViewModel,View } from "binder"
import { ServerConnection } from "src/server/serverConnection";
import { IEditorPart } from "../processDefinition-viewModel";
import  { DataModelDesignerView } from "./dataModelDesigner-view"
import { WindowData } from "src";

export class DataModelDesignerViewModel extends ViewModel implements IEditorPart{
    static newWindowId:number =0;

    
    constructor(parentViewModel: ViewModel) {
        super(parentViewModel);
        this._hasUnsavedChanges = false;
        this.title = 'Data Model';
    }
    GetDefaultView(): View <ViewModel> {
        return new DataModelDesignerView();
    }
    public getTypeId(): string {
        return "VM-6CBDF757-14D0-4CBE-A0F2-BEC9E7E3EC6D"
    }

    public set title(v: string) { this._title = v; } public get title(): string { return this._title;} private _title: string;
    public set content(v: string) { this._content = v; this._hasUnsavedChanges=true; } public get content(): string { return this._content;} private _content: string;
    public set isLoading(v: boolean) { this._isLoading = v; } public get isLoading(): boolean { return this._isLoading;} private _isLoading: boolean;
    private _processId : string;
    private _hasUnsavedChanges : boolean;

    async loadByProcessId(processId: string) {
        try {
            this.isLoading = true;
            this._processId = processId;
            let result = await ServerConnection.callServer('/Complex/BpmsRawDataServices/GetCurrentProcessDataModel',{
                ProcessId: processId
            });
            this.content = result.DataModelXml;
            this._hasUnsavedChanges = false;
        } catch (ex) {
            console.log(ex);
        } finally {
            this.isLoading = false;
        }
    }
    hasUnsavedChanges(): boolean {
        return this._hasUnsavedChanges;
    }

    async save(){
        try {
            this.isLoading = true;
            let result = await ServerConnection.callServer('/Complex/BpmsRawDataServices/UpdateProcessDataModel',{
                ProcessId: this._processId,
                DataModelXml : this.content
            });
            this._hasUnsavedChanges = false;
            this.messageBoxConfirmSuccess("Data Model Saved Successfully",'Saving Data');
        } catch (ex) {
            console.log(ex);
        } finally {
            this.isLoading = false;
        }
    }

    dispose() {
        this.disposeBus();
    }
    disposeBus(broadcastChannel?:BroadcastChannel){
        if(this._bus && (broadcastChannel==null || broadcastChannel==this._bus)){
            try{
                this._bus.postMessage({
                    type:'informClose'
                })
            }catch{}
            let index = WindowData.BroadCastChannels.indexOf(this._bus);
            WindowData.BroadCastChannels.splice(index,1);
            this._bus.close();
            this._bus = null;
        }else if(broadcastChannel){
            try{
                broadcastChannel.postMessage({
                    type:'informClose'
                })
            }catch{}
            
            let index = WindowData.BroadCastChannels.indexOf(broadcastChannel);
            WindowData.BroadCastChannels.splice(index,1);
            broadcastChannel.close();
        }

    }

    private _bus:BroadcastChannel;

    edit(){
        this._hasUnsavedChanges = false;
        if(this._bus){
            this.disposeBus();
        }

        let handler =(msg:MessageEvent<any>)=>{
            let data = msg.data;
            switch(data.type){
                case "ready":
                    bus.postMessage({
                        type:'dataModelCodeSend',
                        code : this.content,
                        name : "Data Model"
                    })
                    break;
                case "changed":
                    this._hasUnsavedChanges = true;
                    break;
                case "newModel":
                    this._hasUnsavedChanges = true;
                    let newCode = data.code;
                    this.content = newCode;
                    break;
            }
        };

        DataModelDesignerViewModel.newWindowId = new Date().getTime();
        let bus :BroadcastChannel = new BroadcastChannel(`datamodel-code-channel-${DataModelDesignerViewModel.newWindowId}`);
        WindowData.BroadCastChannels.push(bus);

        this._bus = bus;

        bus.onmessage = handler;
        
        let newWindow = window.open(`/dataModelCodeEditor.html?a=${DataModelDesignerViewModel.newWindowId}`);

        newWindow.addEventListener('beforeunload',(e)=>{
            this.disposeBus(bus);
            console.log('datamodel editor unload');
        })
    }
}
